
import { useEffect, useRef } from 'react'

// Taken from https://github.com/donavon/use-event-listener
export default function useEventListener (eventName: string, handler: ((arg0: unknown) => unknown), element?: Window | HTMLElement) {
  if (!element && typeof window !== 'undefined') element = window
  const savedHandler = useRef<((arg0: unknown) => unknown)>()

  useEffect(() => {
    savedHandler.current = handler
  }, [handler])

  useEffect(() => {
    const isSupported = !!(element && element.addEventListener)
    if (!isSupported) return

    const eventListenerHandler = event => savedHandler.current && savedHandler.current(event)
    element.addEventListener(eventName, eventListenerHandler)
    return () => element.removeEventListener(eventName, eventListenerHandler)
  }, [eventName, element])
}
